"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _themeUi = require("theme-ui");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _Chip = _interopRequireDefault(require("../Chip/Chip"));

var _FlexCol = _interopRequireDefault(require("../FlexCol/FlexCol"));

var _FlexColItem = _interopRequireDefault(require("../FlexColItem/FlexColItem"));

var _Label = _interopRequireDefault(require("../Label/Label"));

var _RadioWithImage = _interopRequireDefault(require("../Radio/RadioWithImage"));

var _SelectEnhanced = _interopRequireDefault(require("../SelectEnhanced/SelectEnhanced"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Textarea = _interopRequireDefault(require("../Textarea/Textarea"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CheckInResponseContent = function CheckInResponseContent(_ref) {
  var objectiveOptions = _ref.objectiveOptions,
      reflectionPrompt = _ref.reflectionPrompt,
      emotionalResponse = _ref.emotionalResponse,
      formState = _ref.formState,
      onChange = _ref.onChange,
      errors = _ref.errors,
      mostHelpfulOptions = _ref.mostHelpfulOptions,
      onSubmit = _ref.onSubmit,
      isSubmitting = _ref.isSubmitting,
      canSubmit = _ref.canSubmit;
  return (0, _themeUi.jsx)(_react["default"].Fragment, null, (0, _themeUi.jsx)(_FlexCol["default"], {
    sx: {
      justifyContent: 'center',
      mb: 4,
      pb: 4
    }
  }, (0, _themeUi.jsx)(_FlexColItem["default"], {
    cols: 12
  }, (0, _themeUi.jsx)(_FlexCol["default"], {
    sx: {
      alignContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      justifyContent: 'center',
      '> div': {
        pb: 6
      }
    }
  }, (0, _themeUi.jsx)(_FlexColItem["default"], {
    cols: 12
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "heading4"
  }, "How are you going?"), (0, _themeUi.jsx)(_Text["default"], {
    variant: "body",
    sx: {
      pb: 4
    }
  }, "Select the option that best describes your learning progress."), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      justifyContent: 'space-between'
    }
  }, objectiveOptions && objectiveOptions.map(function (objective) {
    return (0, _themeUi.jsx)(_RadioWithImage["default"], _extends({}, objective, {
      name: "objective",
      key: objective.value,
      value: objective.value,
      selected: objective.value === formState.objective,
      validationMessage: errors.objective,
      onClick: onChange
    }));
  }))), (0, _themeUi.jsx)(_FlexColItem["default"], {
    cols: 12
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "heading5"
  }, "Tell me more"), (0, _themeUi.jsx)(_Text["default"], {
    variant: "body",
    sx: {
      pb: 4
    }
  }, !formState.objective || formState.objective === 0 ? 'What can I help you with?' : formState.objective === 1 ? 'What do you still need to do?' : 'What are the main ideas you would teach someone who missed this lesson?'), (0, _themeUi.jsx)(_Textarea["default"], {
    rows: "7",
    name: "inquiry",
    placeholder: "Type here to respond",
    sx: {
      mx: 4,
      width: 'unset',
      resize: 'none'
    },
    value: formState.inquiry,
    validationMessage: errors.inquiry,
    onChange: onChange
  })), (0, _themeUi.jsx)(_FlexColItem["default"], {
    cols: 12
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "body"
  }, "Think about your learning and provide your best response."), (0, _themeUi.jsx)(_Text["default"], {
    variant: "heading5",
    sx: {
      pb: 4
    }
  }, reflectionPrompt), (0, _themeUi.jsx)(_Textarea["default"], {
    rows: "7",
    name: "takeAway",
    placeholder: "Type here to respond",
    sx: {
      mx: 4,
      width: 'unset',
      resize: 'none'
    },
    value: formState.takeAway,
    validationMessage: errors.takeAway,
    onChange: onChange
  })), (0, _themeUi.jsx)(_FlexColItem["default"], {
    cols: 12
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "heading5"
  }, "What could we do differently next time?"), (0, _themeUi.jsx)(_Text["default"], {
    variant: "body",
    sx: {
      pb: 4
    }
  }, "Select the option that you would find most helpful."), (0, _themeUi.jsx)(_SelectEnhanced["default"], {
    sx: {
      mx: 4,
      width: 'unset',
      textAlign: 'left'
    },
    id: "mostHelpful",
    name: "mostHelpful",
    placeholder: "Select an option or type to create your own",
    isClearable: true,
    as: _creatable["default"],
    value: formState.mostHelpful,
    onChange: onChange,
    validationMessage: errors.mostHelpful,
    options: mostHelpfulOptions.map(function (option) {
      return {
        value: option.value,
        label: option.name
      };
    })
  })), (0, _themeUi.jsx)(_FlexColItem["default"], {
    cols: 8
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "heading5"
  }, "How are you feeling about today\u2019s learning?"), (0, _themeUi.jsx)(_Text["default"], {
    variant: "body",
    sx: {
      pb: 4
    }
  }, "Select the two words that best describe how you feel."), (0, _themeUi.jsx)(_FlexCol["default"], {
    sx: {
      justifyContent: 'center',
      flexWrap: 'wrap'
    }
  }, emotionalResponse && emotionalResponse.map(function (emotion) {
    return (0, _themeUi.jsx)(_FlexColItem["default"], {
      key: emotion,
      cols: 3,
      sx: {
        mt: 2
      }
    }, (0, _themeUi.jsx)(_Chip["default"], {
      textVariant: "caption",
      name: "emotionalResponse",
      sx: {
        bg: function bg() {
          return formState.emotionalResponse.includes(emotion) ? 'secondaryLight' : 'white';
        }
      },
      onClick: onChange
    }, emotion));
  }))), (0, _themeUi.jsx)(_FlexColItem["default"], {
    cols: 12
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "heading5"
  }, "Are you okay?"), (0, _themeUi.jsx)(_Label["default"], {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, (0, _themeUi.jsx)(_Checkbox["default"], {
    id: "followUp",
    name: "followUp",
    checked: formState.followUp,
    validationMessage: errors.followUp,
    onChange: onChange
  }), "I\u2019d like to catch up about how I\u2019m feeling")))), (0, _themeUi.jsx)("div", null, (0, _themeUi.jsx)(_Button["default"], {
    onClick: onSubmit,
    loading: isSubmitting,
    disabled: !canSubmit
  }, "Send Response"))));
};

CheckInResponseContent.propTypes = {
  objectiveOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  reflectionPrompt: _propTypes["default"].string,
  emotionalResponse: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  formState: _propTypes["default"].shape({
    objective: _propTypes["default"].number,
    inquiry: _propTypes["default"].string,
    takeAway: _propTypes["default"].string,
    mostHelpful: _propTypes["default"].shape({
      value: _propTypes["default"].string,
      label: _propTypes["default"].string
    }),
    emotionalResponse: _propTypes["default"].arrayOf(_propTypes["default"].string),
    followUp: _propTypes["default"].bool
  }).isRequired,
  errors: _propTypes["default"].shape({
    objective: _propTypes["default"].string,
    inquiry: _propTypes["default"].string,
    takeAway: _propTypes["default"].string,
    mostHelpful: _propTypes["default"].string,
    emotionalResponse: _propTypes["default"].string,
    followUp: _propTypes["default"].string
  }),
  mostHelpfulOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  onChange: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  isSubmitting: _propTypes["default"].bool.isRequired,
  canSubmit: _propTypes["default"].bool.isRequired
};
var _default = CheckInResponseContent;
exports["default"] = _default;